import { Injectable } from '@angular/core';
import { User } from 'src/app/models/user.model';
import { ApiUxService } from 'src/app/shared/api-ux/api-ux.service';
import { ApiUxInitService } from './api-ux-init.service';

@Injectable({
  providedIn: 'root',
})
export class IsAliveService extends ApiUxInitService<User> {
  constructor(apiUxService: ApiUxService) {
    super(apiUxService, 'is-alive');
  }
}
